import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AuthenticationService } from '../../../../../UI/src/app/shared/authentication/authentication.service';
import { BrandingService } from '../../../../../UI/src/app/shared/branding/branding.service';
import { Storage } from '../../../../../UI/src/app/shared/constants';
import { TranslationLoaderService } from '../../../../../UI/src/app/shared/translation/translation-loader.service';

@Component({
  selector: 'navbar',
  templateUrl: 'custom-navbar.html',
})
export class CustomNavbar {
  @Input() text = null;
  public selectedLocale = '';
  public enabledLocales: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private brandingService: BrandingService, private authenticationservice: AuthenticationService, private translationLoader: TranslationLoaderService) {
    
    this.getEnabledLocales();
    if (window.localStorage.getItem(Storage.CULTURE)) {
      this.selectedLocale = window.localStorage.getItem(Storage.CULTURE)
    }
  }

  getlogo() {
    return this.brandingService.getMobileLogoUrl();
  }

  loadTranslations() {
    window.localStorage.setItem(Storage.CULTURE, this.selectedLocale);
    this.translationLoader.checkCultureChange(this.selectedLocale);
    window.location.reload();
  }

  getEnabledLocales() {
    this.authenticationservice.getEnabledLocales().subscribe(
      (response) => {
        this.enabledLocales = response.cultures;
      }, (error) => {
      }
    );
  }

  canHideLanguageSelection() {
    const isUserLoggedin = this.authenticationservice.isUserLoggedin();
    return isUserLoggedin;
  }

  getLogoRedirectionURL() {
    let LogoRedirectURL = window.localStorage.getItem(Storage.LOGO_REDIRECT_URL);
    if(LogoRedirectURL) {
      window.location.href = LogoRedirectURL;
      event.preventDefault();      
    }
  }

  ionViewDidLoad() {
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/custom-navbar/custom-navbar.ts